import React from 'react'
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import OverViewIcon from "../../Icons/OverViewIcon";
import loadable from "@loadable/component";

const ColumnDefinitionComponent = loadable(
  () => import("../../components/ColumnDefinition/ColumnDefinitionList")
);

const ColumnDefinitionList = () => {
  return (
     <>
     <div
            className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
          >
            <OverViewIcon />
            <span className={tw`text-[#5E5757] font-bold text-xl`}>
             Column Definition
            </span>
          </div>
          <ColumnDefinitionComponent/>
    </>
  )
}

export default ColumnDefinitionList